<template>
  <div class="course-list">
    <div class="course-title-container">
      <div class="course-title">
        当前学校已有科目
        <el-select
          class="select"
          v-model="selectText"
          placeholder="分类"
          @change="selectType"
          clearable
        >
          <el-option
            :label="item.dictLabel"
            :value="item.dictValue"
            v-for="item in typeSelectList"
            :key="item.dictValue"
          ></el-option>
        </el-select>
      </div>
      <div class="course-edit">
        <div
          class="edit-update"
          @click="editShow = 'update'"
          v-hasPermi="'sc:course:edit'"
        >
          修改
        </div>
        <div
          class="edit-delete"
          @click="editShow = 'delete'"
          v-hasPermi="'sc:course:delete'"
        >
          删除
        </div>
        <div class="edit-cancel" v-show="editShow" @click="editShow = ''">取消</div>
      </div>
    </div>
    <div class="course-list-container" v-bitmap="getCourseListResult">
      <div class="course-item-container" v-for="(item, index) in courseList" :key="index" v-if="item.courseType !== null">
        <img
          :src="
            $courseList[item.courseName]
              ? $courseList[item.courseName].courseIcon
              : $courseList['其他'].courseIcon
          "
          class="course-icon"
        />
        <span class="course-name">{{ item.courseName }}</span>
        <div
          class="course-update"
          v-show="editShow == 'update'"
          @click="updateClick(item)"
        >
          <i class="iconfont icon-update" />
        </div>
        <div
          class="course-delete"
          v-show="editShow == 'delete'"
          @click="deleteClick(item)"
        >
          <i class="iconfont icon-cancel" />
        </div>
      </div>
      <div class="add-course-container close-state"  v-hasPermi="'sc:course:add'">
        <div
          class="add-button"
          @click="isSelectCourseTypeDialogShow = true"
        >
          <span class="add-narration"
            ><i class="iconfont icon-add-course" />添加科目</span
          >
        </div>
        <!-- <div v-show="isAddCustomCourseModuleShow" class="add-module">
          <input
            type="text"
            ref="addinput"
            class="add-input"
            autofocus="autofocus"
            @blur="addInputBlur"
            v-model.trim="addCourseName"
            :class="
              isAddCustomCourseModuleShow
                ? 'input-open-state'
                : 'input-close-state'
            "
          />
          <div class="confirm-add-button" @click="addCourse">添加</div>
        </div> -->
      </div>
    </div>
    <el-dialog
      title="选择添加科目类型"
      :visible.sync="isSelectCourseTypeDialogShow"
      width="20%"
      center
      :modal="false"
    >
      <div class="select-course-type-containter">
        <button class="select-button default-course" @click="showAddDefaultCourseModule">
          添加默认科目
        </button>
        <button class="select-button custom-course" @click="showAddCustomCourseModult">
          添加自定义科目
        </button>
      </div>
    </el-dialog>
    <!-- 修改科目 -->
    <courseEdit
      :dialogFormVisible.sync="editPopupShow"
      :courseInfo="courseInfo"
      v-show="editPopupShow"
      :typeSelectList="typeSelectList"
      @editCourse="editCourse"
    />
    <!-- 新增科目 -->
    <courseAdd
      :dialogFormVisible.sync="isAddCustomCourseModuleShow"
      v-show="isAddCustomCourseModuleShow"
      @submitCourseList="submitCourseList"
      :typeSelectList="typeSelectList"
    />
  </div>
</template>

<script>
import courseEdit from "../course-edit/course-edit.vue";
import courseAdd from "../course-addPopup/course-addPopup.vue";
export default {
  components: {
    courseEdit,
    courseAdd,
  },
  props: {
    courseList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    getCourseListResult: {
      type: String,
      default: "nullData",
    },
  },
  data() {
    return {
      isSelectCourseTypeDialogShow: false,
      isAddCustomCourseModuleShow: false,
      editShow: "",
      lock: false,
      addCourseName: "",
      editPopupShow: false,
      courseInfo: null,
      typeSelectList: [],
      selectText: "",
    };
  },
  created() {
    this.$eventBus.$off("addCourseSuccess");
    this.$eventBus.$on("addCourseSuccess", (res) => {
      this.addCourseName = "";
      this.isAddCustomCourseModuleShow = false;
      this.lock = false;
    });
    this.$eventBus.$off("addCourseError");
    this.$eventBus.$on("addCourseError", (res) => {
      this.lock = false;
    });
    this.getDictType();
  },
  methods: {
    selectType(e) {
      // console.log(e);
      this.$emit("selectType", e);
    },
    getDictType() {
      this.get(`${this.$url.getDictType}/course_nature`).then((res) => {
        // console.log(res.data);
        this.typeSelectList = res.data;
      });
    },
    addCourse(e) {
      this.lock = true;
      if (this.addCourseName.length == 0) {
        return this.$message.warning("科目名不能为空");
        // return (this.lock = false);
      }
      this.$emit("addCourse", [
        {
          createBy: this.user.id,
          schoolId: this.school.id,
          schoolName: this.school.schoolName,
          courseName: this.addCourseName,
        },
      ]);
    },
    submitCourseList(e) {
      this.$emit("submitCourseList", e);
    },
    showAddCustomCourseModult() {
      this.isSelectCourseTypeDialogShow = false;
      this.isAddCustomCourseModuleShow = true;
      // setTimeout(() => {
      //   this.$refs.addinput.focus();
      // }, 0);
    },
    showAddDefaultCourseModule() {
      this.isSelectCourseTypeDialogShow = false;
      this.$emit("showAddDefaultCourseModule");
    },
    addInputBlur() {
      clearTimeout(blur);
      let blur = setTimeout(() => {
        if (this.lock) {
          return;
        }
        // this.isAddCustomCourseModuleShow = false;
      }, 100);
    },
    editCourse(data) {
      this.$emit("updateCourse", data);
    },
    // 修改科目
    updateClick(item) {
      // console.log(item);
      this.courseInfo = item;
      this.editPopupShow = true;
      // this.$prompt("科目名称", "修改科目", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   inputValue: item.courseName,
      //   inputValidator: (value) => {
      //     // 点击按钮时，对文本框里面的值进行验证
      //     if (!value) {
      //       return "请输入科目";
      //     }
      //   },
      // })
      //   .then(({ value }) => {
      //     // value：输入框的值 item：当前需要修改的项
      //     // console.log(item);
      //     let haveCourse = false;
      //     this.courseList.forEach((cItem) => {
      //       if (value == cItem.courseName) {
      //         haveCourse = true;
      //       }
      //     });
      //     if (haveCourse == true) {
      //       return this.$message.warning("科目已存在");
      //     }
      //     let options = {
      //       id: item.id,
      //       schoolId: this.school.id,
      //       schoolName: this.school.schoolName,
      //       courseName: value,
      //     };
      //     // 传递给父组件
      //     this.$emit("updateCourse", options);
      //     setTimeout(() => {
      //       this.editShow = "";
      //     }, 100);
      //   })
      //   .catch(() => {
      //     // console.log("取消输入");
      //   });
    },
    // 删除科目
    deleteClick(item) {
      this.$confirm("是否确定删除科目?", "删除科目", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // console.log("item=>", item);
          this.$emit("deleteCourse", item);
          // setTimeout(() => {
          //   this.editShow = "";
          // }, 100);
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
@import "./course-list.scss";
</style>
